import React, { useState } from "react";
import { Upload, message, Modal, Image, Button, Typography } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { clientAction } from "../state/actions";
import styles from "../styles/PhotoComp.module.css";
import Checkbox from "antd/lib/checkbox/Checkbox";
import { getPreSignedUrls, uploadFileToS3 } from "../../Common/utils/extraFunctions";
const { Text } = Typography;
function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg" || file.type === "image/webp";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG/JPEG/WEBP file!");
  }
  const isLt5M = file.size / 1024 / 1024 < 100;
  if (!isLt5M) {
    message.error("Image must smaller than 100MB!");
  }
  return isJpgOrPng && isLt5M;
}

function AvatarImage(id) {
  const dispatch = useDispatch();
  const [previewUrl, setPreviewUrl] = useState([]);
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [spinning, setSpinning] = useState(false);
  const [fileText, setFileText] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const [allFiles, setAllFiles] = useState([]);
  const selectedSizeMB = allFiles.filter((_, idx) => selectedFiles.includes(idx)).reduce((acc, file) => acc + file.size, 0) / (1024 * 1024);

  const isTooBig = selectedSizeMB > 100;
  function bytesToSize(bytes) {
    let sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes === 0) return "0 Byte";
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
  }

  let handleCustome = ({ file }) => {
    setVisible(true);

    const fileIndex = allFiles.length;
    setAllFiles((prev) => [...prev, file]);
    setSelectedFiles((prev) => [...prev, fileIndex]); // Mark as checked by default

    setPreviewUrl((prev) => [...prev, URL.createObjectURL(file)]);
    setFileText((prev) => [...prev, { name: file.name, size: bytesToSize(file.size) }]);
  };

  const uploadButton = (
    <div>
      <PlusOutlined style={{ color: "#085191" }} />
    </div>
  );

  const handleCancel = () => {
    setVisible(false);
    setAllFiles([]);
    setPreviewUrl([]);
    setSelectedFiles([]);
    setFileText([]);
  };


  const handleImageUpload = async () => {
    setVisible(false);
    if (selectedFiles.length === 0) return;

    try {
      setLoading(true);

      const selectedUploads = allFiles.filter((_, idx) => selectedFiles.includes(idx));

      const filenames = selectedUploads.map((file) => file.name);
      const presignedUrls = await getPreSignedUrls(filenames, "NOTES");

      if (!presignedUrls || presignedUrls.length !== selectedUploads.length) {
        message.error("Could not generate all upload URLs.");
        return;
      }

      const uploadedLinks = await Promise.all(
        selectedUploads.map(async (file, idx) => {
          const url = presignedUrls[idx]?.url;
          if (!url) return null;

          const uploaded = await uploadFileToS3(file, url);
          if (!uploaded) return null;

          return {
            imageUrl: uploaded,
            name: file.name,
            notes: "",
          };
        })
      );
      const fileData = uploadedLinks.filter(Boolean);
      dispatch(clientAction.postImage({ fileData, id }));
      setAllFiles([]);
      setPreviewUrl([]);
      setSelectedFiles([]);
      setFileText([]);
    } catch (err) {
      message.error("Something went wrong during image upload.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className={styles.uploadButtonbigscreen}>
        <Upload name="avatar" listType="picture-card" className="avatar-uploader" showUploadList={false} customRequest={handleCustome} beforeUpload={beforeUpload} multiple style={{ width: "900px" }}>
          {uploadButton}
        </Upload>
      </div>

      {/* Modal opens when someone select an image for preview*/}
      <Modal
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <div style={{ display: "flex", flexDirection: "column", width: "100%" }} key="footer">
            {isTooBig && (
              <Text type="danger" style={{ textAlign: "center", display: "block", marginBottom: "10px" }}>
                Total selected image size exceeds 100MB. Please unselect some files.
              </Text>
            )}
            <div style={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
              <span>
                <strong>Total Size:</strong> {selectedSizeMB.toFixed(2)} MB
              </span>
              <div style={{ marginTop: "20px", textAlign: "center" }} wrapperCol={{ offset: 0, span: 24 }}>
                <div style={{ marginTop: "30px", textAlign: "center" }} wrapperCol={{ offset: 10, span: 14 }}>
                  <Button type="primary" onClick={handleImageUpload} style={{ marginRight: "15px", marginLeft: "20px" }}>
                    Done
                  </Button>
                  <Button type="primary" onClick={handleCancel} disabled={selectedFiles.length === 0 || isTooBig}>
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>,
        ]}
      >
        {/* Show only when New pic got uploaded */}

        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", maxHeight: "55vh", overflowY: "auto", padding: "10px" }}>
          {previewUrl?.length > 0 &&
            previewUrl.map((url, idx) => (
              <div
                key={idx}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  width: "100%",
                  maxWidth: "500px",

                  marginBottom: "5px", // Centered and spaced

                  borderRadius: "8px",
                  backgroundColor: "#fafafa",
                }}
              >
                <Image src={url} width={40} height={40} style={{ objectFit: "cover" }} preview={true} />
                <div style={{ flex: 1, marginLeft: "15px" }}>
                  <Text strong style={{ fontSize: "13px", display: "block" }}>
                    {fileText[idx]?.name}
                  </Text>
                  <Text type="secondary" style={{ fontSize: "12px" }}>
                    Size: {fileText[idx]?.size}
                  </Text>
                </div>
                <Checkbox
                  checked={selectedFiles.includes(idx)}
                  onChange={(e) => {
                    setSelectedFiles((prev) => (e.target.checked ? [...prev, idx] : prev.filter((i) => i !== idx)));
                  }}
                />
              </div>
            ))}
        </div>
      </Modal>
    </>
  );
}

export default AvatarImage;
